import { useEffect } from "react"
import Lenis from "lenis"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function SmoothScrollProvider({ children }) {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.0,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            wheelMultiplier: 0.9,
            touchMultiplier: 1.8,
            infinite: false,
        })

        // Sync ScrollTrigger with Lenis
        lenis.on('scroll', ScrollTrigger.update)

        // Store raf reference for proper cleanup (bug fix)
        const rafFn = (time) => {
            lenis.raf(time * 1000)
        }

        gsap.ticker.add(rafFn)
        gsap.ticker.lagSmoothing(0)

        return () => {
            gsap.ticker.remove(rafFn)
            lenis.destroy()
        }
    }, [])

    return children
}
